// import { getPageOptions } from '~/reducers/analytics/effects.js' //TODO: verify if needed
// import { AppState } from '~/reducers/index.js' //TODO: are we using state?
// import { getEventContext } from '~/utils/simpleAnalytics.js' //TODO: verify if needed

import { AnalyticsEvent, eventFormatter as eventFormatterV3 } from './v3.ts'
import { environment } from 'src/config/env/env.js'
import { getPageOptions } from '../context/index.ts'
import { getUniqueIdCookie } from '@fubotv/fubo-cookie'
import { cohortingPropertyMapper } from '../utils/cohortingPropertyMapper.ts'
import { Cohorting } from 'node_modules/@fubotv/fubo-schema-ts/common/v3/generic/cohorting.js'
// import { environment } from '../../../config/environment/index.js'

// this payload maps to the `properties` key of the page_view event
// https://github.com/fubotv/fubo-schema/blob/master/schema/protobuf/services/papi/v3/tracking/page_view.proto
declare global {
  interface Window {
    analytics: any
    amplitude: {
      getInstance: () => any
    }
  }
}

const cohortingMap = {
  pageView: () => [],
  cohort: (flagInfo) => flagInfo,
  default: (state) => cohortingPropertyMapper(state),
}

const getCohortingData = (
  type: 'page_view' | 'cohorting_event' | 'ui_interaction' | 'ui_render' | 'default',
  flagInfo?: Cohorting[],
  state?: any
) => {
  return type === 'page_view'
    ? cohortingMap.pageView()
    : type === 'cohorting_event'
      ? cohortingMap.cohort(flagInfo)
      : cohortingMap.default(state)
}

export const fireProtoAnalyticsEvent = (event: AnalyticsEvent, state) => {
  return new Promise((resolve, reject) => {
    let analyticsEvent = null
    if (typeof window !== 'undefined' && window.analytics) {
      try {
        window.analytics.ready(() => {
          let flagInfo: Cohorting[] = []

          const { market } = state

          const amplitudeInstance = window?.amplitude?.getInstance()
          const amplitudeDeviceId = amplitudeInstance?.options?.deviceId
          const uniqueId = amplitudeDeviceId || getUniqueIdCookie()
          const flags = cohortingPropertyMapper(state)
          const findFlag = (flag) => (flag ? flags.filter((f) => f.experiment_name === flag) : [])

          const eventProperties = event.eventContext
          if (eventProperties?.flag) {
            flagInfo = findFlag(eventProperties?.flag)
          }

          const cohorting = getCohortingData(event.name, flagInfo, state)

          const eventContext = {
            ...getPageOptions(),
            cohorting,
            market: market.market,
            lang: market.lang,
            sport_id: market?.sportId?.toString(),
            team_id: market?.teamId?.toString(),
            league_id: market?.leagueId?.toString(),
          }

          event.eventContext = { ...eventContext, ...eventProperties }
          analyticsEvent = eventFormatterV3({
            event,
            locationData: market,
            language: market?.language,
            uniqueId,
          })
          resolve(analyticsEvent)
          window.analytics.track(event.name, analyticsEvent.properties)
        })
      } catch (err) {
        environment.environment.env !== 'production' && console.error(err)
      }
    } else {
      resolve(analyticsEvent)
    }
  })
}

export const fireProtoPageView = async (state) => {
  return fireProtoAnalyticsEvent(
    {
      name: 'page_view',
      category: 'acquisition_context',
      subCategory: 'navigation',
    },
    state
  )
}

export const fireUIInteractionEvent = (properties, state) => {
  return fireProtoAnalyticsEvent(
    {
      name: 'ui_interaction',
      category: 'marketing',
      subCategory: 'marketing',
      eventContext: properties,
    },
    state
  )
}

export const fireUIRenderEvent = (properties, state) => {
  fireProtoAnalyticsEvent(
    {
      name: 'ui_render',
      category: 'user_action',
      subCategory: 'element_render',
      eventContext: properties,
    },
    state
  )
}

export const fireCohortingEvent = (flag, state) => {
  return fireProtoAnalyticsEvent(
    {
      name: 'cohorting_event',
      category: 'experiment',
      subCategory: 'growth',
      eventContext: {
        flag,
      },
    },
    state
  )
}
